import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaWhatsapp, FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";

const locations = [
  {
    name: "New Moon Rooms",
    address: "Corso Cavour, 160",
    city: "La Spezia",
  },
  {
    name: "New Moon del Prione",
    address: "Via del Prione, 165",
    city: "La Spezia",
  },
];

const URL_CONTATTO = "https://n8n.newmoonrooms.it/webhook/contatto-sito";

const Contact = () => {
  const { t, i18n } = useTranslation();
  const [dati, setDati] = useState({ nome: "", email: "", messaggio: "", company: "" });
  const [stato, setStato] = useState("fermo"); // fermo | invio | inviato | errore

  const aggiorna = (campo) => (e) =>
    setDati((d) => ({ ...d, [campo]: e.target.value }));

  const invia = async (e) => {
    e.preventDefault();
    if (stato === "invio") return;
    setStato("invio");
    try {
      const r = await fetch(URL_CONTATTO, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...dati,
          lingua: i18n.language,
          pagina: window.location.pathname,
        }),
      });
      if (!r.ok) throw new Error("risposta non ok");
      setStato("inviato");
      setDati({ nome: "", email: "", messaggio: "", company: "" });
    } catch (err) {
      setStato("errore");
    }
  };

  return (
    <section id="contact" className="w-full bg-lux-surface z-10">
      <div className="max-w-[1500px] mx-auto">
        <div className="flex flex-col md:flex-row justify-center">
          <div className="w-full md:w-1/3 p-8 text-lux-cream">
            <h1 className="font-sans text-lux-accent text-[12px] font-bold tracking-widest">
              {t("contact.subtitle")}
            </h1>
            <h2 className="text-4xl font-medium tracking-wide">{t("contact.title")}</h2>

            {/* Two Addresses */}
            <div className="mt-6 space-y-4">
              {locations.map((location, index) => (
                <div key={index} className="flex items-start">
                  <div className="mr-4 text-lux-accent text-xl mt-1">
                    <FaLocationDot />
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-lux-cream">
                      {location.name}
                    </h3>
                    <p className="text-lux-cream/90">{location.address}</p>
                    <p className="text-lux-cream/70 text-sm">{location.city}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex items-center mt-5">
              <div className="mr-4 text-lux-accent text-2xl">
                <FaWhatsapp />
              </div>
              <div>
                <h3 className="font-sans text-[12px] tracking-widest text-lux-accent uppercase">
                  {t("contact.phone")}
                </h3>
                <a
                  className="text-lux-cream/90 hover:underline"
                  href="https://wa.me/393348956214"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +39 334 895 6214
                </a>
              </div>
            </div>
            <div className="flex items-center mt-4">
              <div className="mr-4 text-lux-accent text-2xl">
                <MdEmail />
              </div>
              <div>
                <h3 className="font-sans text-[12px] tracking-widest text-lux-accent uppercase">
                  {t("contact.questions")}
                </h3>
                <a
                  className="text-lux-cream/90 hover:underline"
                  href="mailto:info@newmoonrooms.it"
                >
                  info@newmoonrooms.it
                </a>
              </div>
            </div>
          </div>
          <div className="w-full md:w-2/3 p-8">
            <form onSubmit={invia} className="mt-2 bg-lux-bg p-6 rounded-lg border border-lux-muted">
              <h3 className="text-lux-cream text-xl font-bold mb-4">
                {t("contact.sendMessage")}
              </h3>
              <div className="flex flex-col md:flex-row gap-4">
                <div className="w-full md:w-1/2">
                  <label
                    className="text-lux-cream text-sm font-medium"
                    htmlFor="name"
                  >
                    {t("contact.fullName")}
                  </label>
                  <input
                    className="w-full mt-2 p-3 rounded-md bg-[#14120f] text-[#f5f1e8] border border-lux-muted focus:border-lux-accent focus:outline-none transition-colors placeholder:text-[#f5f1e8]/35"
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={dati.nome}
                    onChange={aggiorna("nome")}
                    placeholder={t("contact.namePlaceholder")}
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <label
                    className="text-lux-cream text-sm font-medium"
                    htmlFor="email"
                  >
                    Email
                  </label>
                  <input
                    className="w-full mt-2 p-3 rounded-md bg-[#14120f] text-[#f5f1e8] border border-lux-muted focus:border-lux-accent focus:outline-none transition-colors placeholder:text-[#f5f1e8]/35"
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={dati.email}
                    onChange={aggiorna("email")}
                    placeholder={t("contact.emailPlaceholder")}
                  />
                </div>
              </div>
              <div className="mt-4">
                <label
                  className="text-lux-cream text-sm font-medium"
                  htmlFor="message"
                >
                  {t("contact.message")}
                </label>
                <textarea
                  className="w-full mt-2 p-3 rounded-md bg-[#14120f] text-[#f5f1e8] border border-lux-muted focus:border-lux-accent focus:outline-none transition-colors placeholder:text-[#f5f1e8]/35"
                  id="message"
                  name="message"
                  rows="4"
                  required
                  value={dati.messaggio}
                  onChange={aggiorna("messaggio")}
                  placeholder={t("contact.messagePlaceholder")}
                ></textarea>
              </div>
              {/* campo invisibile: i bot lo compilano, le persone no */}
              <input
                type="text"
                name="company"
                tabIndex={-1}
                autoComplete="off"
                value={dati.company}
                onChange={aggiorna("company")}
                className="hidden"
                aria-hidden="true"
              />

              <button
                type="submit"
                disabled={stato === "invio"}
                className="mt-4 bg-lux-accent-strong hover:bg-lux-highlight text-[#161310] font-semibold py-3 px-8 rounded-sm border-0 transition-colors disabled:opacity-60"
              >
                {stato === "invio" ? t("contact.sending") : t("common.sendMessage")}
              </button>

              {stato === "inviato" && (
                <p className="mt-4 bg-lux-ok-bg text-lux-ok text-sm font-medium p-3">
                  {t("contact.success")}
                </p>
              )}
              {stato === "errore" && (
                <p className="mt-4 bg-lux-no-bg text-lux-no text-sm font-medium p-3">
                  {t("contact.error")}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
